import { css } from '@emotion/react'
import useGetVendorProductDetailQuery from '@src/hooks/queries/product/useGetVendorProductDetailQuery'
import { useParams } from 'react-router-dom'
import ProductInfo from '@src/components/product/detail/ProductInfo'
import ProductDescriptions from '@src/components/product/detail/ProductDescriptions'

const ProductDetailPage = () => {
	const { productNo } = useParams()
	const { data } = useGetVendorProductDetailQuery(
		{
			productNo: productNo || '',
		},
		{ enabled: true },
	)

	const product = data?.data?.product
	return (
		<div css={pageStyle}>
			<div css={detailSectionStyle}>
				<ProductInfo product={product} />
				<ProductDescriptions descriptions={product?.descriptions} />
			</div>
		</div>
	)
}

const pageStyle = css`
	overflow-y: scroll;
	height: 100%;
	width: 100%;
	overflow-x: hidden;
`
const detailSectionStyle = css`
	padding: 5rem;
	width: 120rem;
	margin: auto;
`
export default ProductDetailPage
